export default "__VITE_ASSET__741f4886__"